import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-loader-common',
  templateUrl: './loader-common.component.html',
  styleUrls: ['./loader-common.component.scss']
})
export class LoaderCommonComponent {

}
